<template>
  <div class="ticketBooking">
    <div class="ticketBooking-top">
      <i class="iconfont">&#xe632;</i>志愿者报名
    </div>
    <div class="ticketBookingBox" v-for="item in list" :key="item.activityId">
      <div class="ticketBookingBox-boxTops">
        <div class="text">
          <i class="iconfont">&#xe607;</i>
          签到日期：{{formatTime(item.activityStaTime)}} {{getTime(item.activityStaTime)}} - {{getTime(item.activityEndTime)}}
        </div>
      </div>
      <div
        class="ticketBookingBox-boxTop"
        v-touch:tap="$gotoDetail(item.activityId,item.volunteerId)"
      >
        <div class="ticketBookingBox-boxTop-left">{{item.activityName}}</div>
        <div class="boxTop-lefts">
          积分：
          <span class="integral">{{item.scoreNum}}</span>
        </div>
      </div>
      <div class="ticketBookingBox-boxBottom">
        <template v-if="item.entryStatus==1">
          <div class="boxBottom-text">预约成功</div>
          <div
            class="boxBottom-text2"
            v-touch:tap="cancel(item.activityId,item.volunteerId)"
            v-if="item.allowCancel==1"
          >取消预约</div>
          <div
            class="boxBottom-text3"
            v-touch:tap="gotoQRCodeVolunteer( item.activityId, item.volunteerId )"
          >
            <i class="iconhebei iconerweima"></i>签到二维码
          </div>
        </template>
        <template v-if="item.entryStatus==2">
          <div class="boxBottom-text4">已取消预约</div>
          <div
            class="boxBottom-text2"
            v-touch:tap="deleteEntry(item.activityId,item.volunteerId)"
          >删除</div>
        </template>
      </div>
    </div>
    <div v-if="list.length === 0 " class="tips-font">没有更多了</div>
  </div>
</template>
<script>
import http from "@js/http-zyz.js";
import util from "@util";

import { entryList, cancelEntry, delEntry } from "@js/volunteerUrl";
export default {
  name: "sign-up",
  data() {
    return {
      list: []
    };
  },
  created() {
    this.getEntryList();
  },
  methods: {
    getEntryList() {
      http
        .post(entryList, {
          openId: this.openId
        })
        .then(res => {
          res.data.data.activityList.map(item=>{
            // "2020/01/21 00:00:00" IOS转换正常
            // "2020-01-21 00:00:00" IOS转换不出 会成为NAN
            item.activityStaTime = item.activityStaTime.replace(/-/g,'/')
            item.activityEndTime = item.activityEndTime.replace(/-/g,'/')
          })
          this.list = res.data.data.activityList;
        });
    },
    //取消预约
    cancel(activityId, volunteerId) {
      return () => {
        this.$dialog
          .confirm({
            title: "警告",
            message: "确定取消该预约?"
          })
          .then(() => {
            let params = {
              openId: this.openId,
              activityId,
              volunteerId
            };
            http.post(cancelEntry, params).then(res => {
              if (res.data.data.success) {
                this.getEntryList();
              }
            });
          });
      };
    },
    deleteEntry(activityId, volunteerId) {
      return () => {
        this.$dialog
          .confirm({
            title: "警告",
            message: "确定删除该记录?"
          })
          .then(() => {
            let params = {
              openId: this.openId,
              activityId,
              volunteerId
            };
            http.post(delEntry, params).then(res => {
              if (res.data.data.success) this.getEntryList();
            });
          });
      };
    },
    //电子二维码
    gotoQRCodeVolunteer(activityId, volunteerId) {
      return () => {
        this.$router
          .push({
            path: "qrcodev",
            query: { activityId, volunteerId }
          })
          .catch(err => {
            err;
          });
      };
    },
    //删除
    removeBtn() {
      return () => {
        // console.log(111);
      };
    },
    //报名详情页面
    $gotoDetail(activityId, volunteerId) {
      return () => {
        this.$router
          .push({
            path: "registrationDetails",
            query: { activityId, volunteerId }
          })
          .catch(err => {
            err;
          });
      };
    },
    formatTime(time) {
      return util.formatTime(new Date(time), "yyyy-MM-dd");
    },
    getTime(item) {
      return util.getTime(item);
    }
  },
  computed: {
    openId() {
      return this.$store.state.userInfo.openId;
    }
  }
};
</script>

<style lang="less" scoped>
.ticketBooking {
  background-color: #f1effb !important;
  padding: 20px 7px;
  .iconhebei {
    display: inline-block;
    margin-right: 10px;
    transform: translateY(2px);
  }
  .tips-font{
    font-size: 14px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    color: #969799;
  }
  .ticketBooking-top {
    padding: 0 17px;
    color: #606060;
    font-size: 14px;
    line-height: 20px;
    .iconfont {
      color: #5a9bf6;
      padding-right: 6px;
      font-size: 18px;
    }
  }
  .ticketBookingBox {
    margin-top: 13px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    padding: 0 8px;
    .ticketBookingBox-boxTop {
      padding: 15px 10px;
      zoom: 1;
      overflow: auto;
      border-bottom: 0.5px solid #d8d8d8;
      .boxTop-lefts {
        margin-top: 10px;
        line-height: 20px;
        font-size: 14px;
        color: #b3b3b3;
        font-weight: 500;
        .integral {
          color: #ff8d09;
          font-size: 14px;
          font-weight: 500;
        }
      }
    }
    .ticketBookingBox-boxTops {
      padding: 15px 10px;
      border-bottom: 0.5px solid #d8d8d8;
      display: -webkit-flex;
      display: flex;
      .text {
        color: #606060;
        font-size: 12px;
        line-height: 20px;
      }
      .iconfont {
        color: #5a9bf6;
        padding-right: 10px;
      }
    }
    .ticketBookingBox-boxTop {
      padding: 15px 10px;
      zoom: 1;
      overflow: auto;
      border-bottom: 0.5px solid #d8d8d8;
      .ticketBookingBox-boxTop-left {
        color: #464e55;
        font-size: 14px;
        font-weight: 500;
      }
    }
    .ticketBookingBox-boxBottom {
      padding: 15px 10px;
      zoom: 1;
      overflow: auto;
      .boxBottom-text {
        font-size: 14px;
        color: #27af2d;
        width: 80px;
        float: left;
      }
      .boxBottom-text2 {
        float: left;
        color: #b3b3b3;
        font-size: 14px;
      }
      .boxBottom-text3 {
        float: right;
        color: #606060;
        font-size: 12px;
        text-align: right;
        line-height: 16px;
        .iconfont {
          padding-right: 6px;
        }
      }
      .boxBottom-text4 {
        font-size: 14px;
        color: #7a7a7a;
        width: 80px;
        float: left;
      }
    }
  }
}
</style>